// Typelizer digest 5b7ce9536accc33c9c68fd8178d29a70
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/documents/:document_id/payments */
  create: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/payments', params, options),
    method: 'post',
  }),

  /** DELETE /c/:company_id/documents/:document_id/payments/:id */
  destroy: (
    params: { documentId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/payments/:id', params, options),
    method: 'delete',
  }),
}
